import { Panne, InstalledSparepart } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"

function mapInstalledSparePart(input: any): InstalledSparepart {
    return {
        id: input.id,
        sparepartId: input.sparepartId ?? input.sparePartId,
        taskId: input.taskId,
        panneId: input.panneId,
        quantity: input.quantity,
        displayName: input.displayName
    };
}

function modelMapper(inputPanne: any): Panne {
    const sparepartsList = inputPanne.installedSpareparts ?? inputPanne.installedSpareParts ?? [];
    return {
        id: inputPanne.id,
        productAquaNumber: inputPanne.productAquaNumber,
        creationDate: inputPanne.creationDate,
        reparationDate: inputPanne.reparationDate,
        name: inputPanne.name,
        desc: inputPanne.desc,
        repaired: inputPanne.repaired,
        installedSpareParts: sparepartsList.map(mapInstalledSparePart)
    };
}

export function modelMapperArray(inputArray: any[]): Panne[] {
    return inputArray.map(modelMapper);
}

export async function getPannesByProduct(productId: string, repaired?: boolean): Promise<Panne[]> {
    const query = repaired !== undefined ? `?repaired=${repaired}` : "";
    const pannes = await getData<Panne[]>("products/" + productId + "/pannes" + query);
    return modelMapperArray(pannes ?? []);
}

export async function fetchPanneByTask(taskId: string): Promise<Panne | null> {
    const panne = await getData<Panne>("tasks/" + taskId + "/panne");
    if (!panne) {
        return null;
    }
    return modelMapper(panne);
}

export function getPanneById(panneId: string): Promise<Panne> {
    return getData("pannes/" + panneId).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function postPanne(panne: Panne, productId: string): Promise<Panne> {
    return postData("products/" + productId + "/pannes", panne).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function putPanne(panne: Panne): Promise<any> {
    return putData("pannes/" + panne.id, panne)
}

export function deletePanne(panneId: string): Promise<any> {
    return deleteData("pannes/" + panneId)
}